import { Timestamp } from "firebase/firestore";
import { SearchHelper } from "../../utils/helpers";

export const acquirerToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    const tenantName = typeof tenantData === 'string' ? '' : (tenantData?.tenantName || tenantData?.name || '');
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const cleanName = data.name?.trim() || "Nova Adquirente";

    const payload = {
        idTenant,
        tenantName,
        name: cleanName,
        searchName: SearchHelper.normalize(cleanName),
        status: data.status,

        // Taxas por bandeira — mapa dinâmico { visa: {...}, mastercard: {...} }
        rates: data.rates && typeof data.rates === 'object' ? data.rates : {},

        // Antecipação de Recebíveis
        anticipation: {
            enabled: !!data.anticipation?.enabled,
            type: data.anticipation?.type,
            feePerMonth: Number(data.anticipation?.feePerMonth),
            settlementDays: Number(data.anticipation?.settlementDays),
        },

        // Conta bancária de depósito padrão
        idBankAccount: data.idBankAccount,
        bankAccountName: data.bankAccountName,

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: (data.id && data.createdBy) ? data.createdBy : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    // Remove undefined
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

    return payload;
};

/**
 * Mapeia os dados do Firestore para o React.
 */
export const acquirerFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
